import { OrderedMap, OrderedSet, Record } from "immutable";
import categories from "constants/brand-categories";
import Globalize from "globalize";
import me from "models/me";

const defaults = {
    store_name: "",
    website: "",
    phone_number: "",
    seller_permit_no: "",
    years_in_business: "",
    number_of_stores: "",

    country: "United States",
    address_line_1: "",
    address_line_2: "",
    city: "",
    state: "",
    zip: "",

    categories: OrderedMap(),

    brands_stocked: OrderedSet(),
    store_description: "",
    image_url: "",
};

export class RetailerProfile extends Record(defaults) {
    declare store_name: string;
    declare website: string;
    declare phone_number: string;
    declare seller_permit_no: string;
    declare years_in_business: string;
    declare number_of_stores: string;

    declare country: string;
    declare address_line_1: string;
    declare address_line_2: string;
    declare city: string;
    declare state: string;
    declare zip: string;

    declare categories: OrderedMap<string, OrderedSet<string>>;

    declare brands_stocked: OrderedSet<string>;
    declare store_description: string;
    declare image_url: string;

    toLegacyFormat(brandCategories: any) {
        // TODO: seller_permit_no, years_in_business, number_of_stores
        return {
            active: true,
            initiated_by_retailer: true,
            name: this.store_name,
            website: this.website,
            phone: this.phone_number,
            addresses: [
                {
                    country: this.country,
                    line_1: this.address_line_1,
                    line_2: this.address_line_2,
                    state: this.state,
                    city: this.city,
                    zip: this.zip,
                },
            ],
            brands: this.brands_stocked.toJS(),
            images: this.image_url ? [this.image_url] : [],
            retail_categories: this.categories
                .filter((subcategories) => !subcategories.isEmpty())
                .map((subcategories, key) => ({
                    name: Globalize.formatMessage(categories[key]),
                    subcategories: subcategories.map((slug) => brandCategories[slug].name).toJS(),
                }))
                .toArray(),
            header_image: "default",
            description: this.store_description,
            seller_permit_number: this.seller_permit_no,
            years_in_business: this.years_in_business,
            number_of_stores: this.number_of_stores,
            email: me.email,
        };
    }
}
